import React from 'react'
import { invoiceItem } from '../utils/constant';
import { useTranslation } from 'react-i18next';

const AccommodationOption = () => {
    const { t } = useTranslation();
    const kingRoom1PPrice = invoiceItem(t).find((item) => item.key === "king_1p").amount;
    const twinRoom2PPrice = invoiceItem(t).find((item) => item.key === "twin_2p").amount;
    const extendStayPrice = invoiceItem(t).find((item) => item.key === "extendStay").amount;
    return (
        <>
            <h4 className='mt-5'>{t("accomodation.StayOP")}</h4>
            <table className="table table-info table-striped">
                <thead>
                    <tr>
                        <th scope="col"></th>
                        <th scope="col">{t("accomodation.contentTitle")}</th>
                        <th scope="col">{t("accomodation.contentTitle2")}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th className='th-row' scope="row">
                            {t("Constant.TwinRoom")}<br />{t("Constant.twinBedSize")}
                        </th>
                        <td>
                            {
                                t("accomodation.doubleRoomPrice", {
                                    double_room_price: twinRoom2PPrice,
                                })
                            }
                        </td>
                        <td>
                            {
                                t("accomodation.extendStayPrice", {
                                    extend_stay_price: extendStayPrice,
                                })
                            }
                        </td>
                    </tr>
                    <tr>
                        <th className='th-row' scope="row">
                            {t("Constant.KingRoomDoubleOccupancy")}<br />{t("Constant.kingBedSize")}
                        </th>
                        <td>
                            {
                                t("accomodation.doubleRoomPrice", {
                                    double_room_price: twinRoom2PPrice,
                                })
                            }
                        </td>
                        <td>
                            {
                                t("accomodation.extendStayPrice", {
                                    extend_stay_price: extendStayPrice,
                                })
                            }
                        </td>
                    </tr>
                    <tr>
                        <th className='th-row' scope="row">
                            {t("Constant.KingRoom")}<br />{t("Constant.kingBedSize")}
                        </th>
                        <td>
                            {
                                t("accomodation.singleRoomPrice", {
                                    single_room_price: kingRoom1PPrice,
                                })
                            }
                        </td>
                        <td>
                            {
                                t("accomodation.extendStayPrice", {
                                    extend_stay_price: extendStayPrice,
                                })
                            }
                        </td>
                    </tr>
                </tbody>
            </table>
        </>
    )
}

export default AccommodationOption